﻿document.addEventListener("DOMContentLoaded", function () {
    const searchButton = document.getElementById("navbar_search");
    const searchPopup = document.getElementById("search_popup");
    const searchInput = document.getElementById("search_input");
    const overlay = document.querySelector(".__ds_page_loading");
    const search_results = document.getElementById("search_results");
    const closeSearchButton = document.querySelector('#search_popup .close-search');
    const progressbar = document.getElementById('loading-bar');
    let searchController;
    let debounceTimer = null;
    let currentSearchType = 'contacts';

    if (!searchButton || !searchPopup || !overlay) return;

    // handle a click in search results and enable progress bar
    search_results.addEventListener('click', () => {
        progressbar.querySelector('.bar').classList.remove('d-none');
    });

    /**
     * this handles the suggested filter clicks
     */
    document.querySelectorAll('.suggested-item').forEach(item => {
        item.addEventListener('click', function (e) {
            const el = e.currentTarget;
            searchInput.value = el.dataset.filter;

            // hide noresults
            document.querySelectorAll('.noresults').forEach(p => p.classList.add('d-none'));

            search();

            setTimeout(() => {
                searchInput?.focus();
            }, 0);
        });
    });

    // this handles toggling between search types
    document.querySelectorAll('.toggle').forEach(pill => {
        pill.addEventListener('click', function (e) {
            e.preventDefault();

            // 1. Update Visual State
            document.querySelectorAll('.toggle').forEach(p => p.classList.remove('active'));
            this.classList.add('active');

            // hide noresults
            document.querySelectorAll('.noresults').forEach(p => p.classList.add('d-none'));

            search_results.innerHTML = "";

            // 2. Update Logic State
            currentSearchType = this.getAttribute('data-type');

            // Set a context aware placeholder
            switch (currentSearchType) {
                case "assets":
                    searchInput.placeholder = "Search marketing assets ...";
                    break;
                case "contacts":
                    searchInput.placeholder = "Search contacts ...";
                    break;
                case "docs":
                    searchInput.placeholder = "Search by keyword or ask a question ...";
                    break;
                case "crm":
                    searchInput.placeholder = "Search opportunities and tasks ...";
                    break;
            }

            // Show suggested filters
            if (searchInput.value.trim() === "") {
                switch (currentSearchType) {
                    case "assets":
                        document.getElementById('suggested_filters_assets').classList.remove('d-none');
                        break;
                    case "contacts":
                        document.getElementById('suggested_filters_contacts').classList.remove('d-none');
                        break;
                }
            }

            search();

            setTimeout(() => {
                searchInput?.focus();
            }, 0);
        });
    });

    // this handles control k or equivalent in mac
    document.addEventListener("keydown", (e) => {
        const isMac = navigator.userAgentData?.platform === "macOS";

        // Ignore if typing in an input, textarea, or contenteditable
        const tag = document.activeElement?.tagName;
        if (
            tag === "INPUT" ||
            tag === "TEXTAREA" ||
            document.activeElement?.isContentEditable
        ) {
            return;
        }

        if ((isMac ? e.metaKey : e.ctrlKey) && e.key.toLowerCase() === "k") {
            e.preventDefault();
            openSearch();
        }
    });

    function openSearch() {
        searchPopup.classList.remove("d-none");
        overlay.style.display = "initial";
        document.body.style.overflow = 'hidden';
        document.querySelectorAll('.noresults').forEach(p => p.classList.add('d-none'));

        // Show recommended filters
        document.getElementById('suggested_filters_contacts').classList.remove('d-none');

        setTimeout(() => {
            searchInput?.focus();
        }, 0);
    }

    function closeSearch() {
        searchPopup.classList.add("d-none");
        overlay.style.display = "none";
        document.body.style.overflow = '';
        search_results.innerHTML = "";
        searchInput.value = "";

        // hide all no results
        document.querySelectorAll('.noresults').forEach(p => p.classList.add('d-none'));

        // Reset the seach toggle
        document.querySelectorAll('.toggle').forEach(p => p.classList.remove('active'));
        document.querySelector('.toggle[data-type="contacts"]').classList.add('active');
        currentSearchType = 'contacts';

        // hide animated progress bar
        progressbar.querySelector('.bar').classList.add('d-none');
    }

    // Open search
    searchButton.addEventListener("click", function (e) {
        e.stopPropagation();
        openSearch();
    });

    // Clear search
    closeSearchButton.addEventListener('click', function (e) {
        closeSearch();
    });

    // Close on ESC
    document.addEventListener("keydown", function (e) {
        if (e.key === "Escape" && !searchPopup.classList.contains("d-none")) {
            closeSearch();
        }
    });

    // Close when the page is restored from the back/forward (bfcache) cache,
    // where DOMContentLoaded doesn't fire and the popup would stay open
    window.addEventListener("pageshow", function () {
        if (!searchPopup.classList.contains("d-none")) {
            closeSearch();
        }
    });

    /**
     * Search input handling with debounce
     */
    searchInput?.addEventListener("input", async () => {
        clearTimeout(debounceTimer);

        const value = searchInput.value.trim();
        if (!value) return;
        if (value.length < 3) return;

        debounceTimer = setTimeout(async () => {
            // If there's an existing search, cancel it
            if (searchController) searchController.abort();

            // Create a new controller for THIS search
            searchController = new AbortController();

            try {
                // hide all no results
                document.querySelectorAll('.noresults').forEach(p => p.classList.add('d-none'));
                // clear previous results
                search_results.innerHTML = ""; 

                await search(searchController.signal);

            } catch (err) {
                if (err.name === 'AbortError') return; // Expected, ignore
                console.error(err);
            }
        }, 400);
    });

    /**
     * Search
     * @returns
     */
    async function search(signal) {
        const value = searchInput.value.trim();

        if (!value) return;

        // clear previous results
        search_results.innerHTML = "";

        // enable the progress bar
        progressbar.querySelector('.bar').classList.remove('d-none');

        switch (currentSearchType) {
            case "contacts":
                await searchContacts(value);
                break;

            case "docs":
                await searchHelpDocs(value, search_results, signal);
                break;
            case "developer":
                await searchDeveloperDocs(value);
                break;

            case "crm":
                await searchCrm(value);
                break;

            case "assets":
            case "default":
                await searchAssets(value);
                break;

        }

        // disable the progress bar
        progressbar.querySelector('.bar').classList.add('d-none');
    }

    async function searchAssets(query) {
        try {
            const response = await fetch(
                `/api/v1/globalsearch/?s=${encodeURIComponent(query)}`,
                { method: "GET" }
            );

            if (!response.ok) {
                console.error("Search failed:", response.status);
                return;
            }

            const json = await response.json();
            const results = json.Response.results;

            // Navigation assistance
            if (results?.navigation.length > 0) {

                results?.navigation.slice(0, 3).forEach(asset => {
                    const anchor = document.createElement("a");
                    const name = asset.name.replace(/>/g, '<i class="fa-regular fa-angle-right ms-1 me-1" aria-hidden="true"></i>');
                    const asset_icon = getAssetIcon(asset.asset_type);
                    anchor.classList.add("d-flex", "align-items-center", "cg-3", "search-result-item");
                    anchor.href = asset.description;

                    anchor.innerHTML = `${asset_icon}
                        <div style="width:100%">
                        <div class="name">${name}</div>
                        </div><i class="fa-regular fa-angle-right navigate-to"></i>`;

                    search_results.appendChild(anchor);
                });

            }

            // Assets
            results?.assets.slice(0, 10).forEach(asset => {
                const anchor = document.createElement("a");
                anchor.classList.add("d-flex", "align-items-center", "cg-3", "search-result-item");

                const campaign = asset.campaign_id ? `<a href="/campaign/detail/${asset.campaign_id}">${asset.campaign_name}</a><span class="pill gray uppercase">campaign</span>` : "";
                const asset_icon = getAssetIcon(asset.asset_type);
                const asset_description = asset.description || "";
                const status_pill = getStatusPill(asset.asset_type, asset.status);

                switch (asset.asset_type) {
                    case "TextMessage":
                        anchor.href = `/sms/edit/${asset.asset_id}`;
                        anchor.innerHTML = `${asset_icon}
                        <div style="width:100%">
                        <div class="name">Text Messages<i class="fa-regular fa-angle-right ms-1 me-1" aria-hidden="true"></i>${asset.name}</div>
                        <div class="description clamp-3">${asset_description}</div>${campaign}
                        </div>`;
                        break;
                    case "Segment":
                        anchor.href = `/segment/dashboard/${asset.asset_id}`;
                        anchor.innerHTML = `${asset_icon}
                        <div style="width:100%">
                        <div class="name">Segments<i class="fa-regular fa-angle-right ms-1 me-1" aria-hidden="true"></i>${asset.name}</div>
                        <div class="description clamp-3">${asset_description}</div>
                        </div>`;
                        break;
                    case "Automation":
                        anchor.href = `/autopilot/edit/${asset.asset_id}`;
                        anchor.innerHTML = `${asset_icon}
                        <div style="width:100%">
                        <div class="name">Automations<i class="fa-regular fa-angle-right ms-1 me-1" aria-hidden="true"></i><div class="d-flex align-items-center">${asset.name}${status_pill}</div></div>
                        <div class="description clamp-3">${asset_description}</div>${campaign}
                        </div>`;
                        break;
                    case "Email":
                        anchor.href = `/email/edit/${asset.asset_id}`;
                        anchor.innerHTML = `${asset_icon}
                        <div style="width:100%">
                        <div class="name">Emails<i class="fa-regular fa-angle-right ms-1 me-1" aria-hidden="true"></i>${asset.name}</div>
                        <div class="description clamp-3">${asset_description}</div>${campaign}
                        </div>`;
                        break;
                    case "WebForm":
                        anchor.href = `/webform/edit/${asset.asset_id}`;
                        anchor.innerHTML = `${asset_icon}
                        <div style="width:100%">
                        <div class="name">Web Forms<i class="fa-regular fa-angle-right ms-1 me-1" aria-hidden="true"></i>${asset.name}</div>
                        <div class="description clamp-3">${asset_description}</div>${campaign}
                        </div>`;
                        break;
                    case "MagicForm":
                        anchor.href = `/magicform/edit/${asset.asset_id}`;
                        anchor.innerHTML = `${asset_icon}
                        <div style="width:100%">
                        <div class="name">Magic Forms<i class="fa-regular fa-angle-right ms-1 me-1" aria-hidden="true"></i>${asset.name}</div>
                        <div class="description clamp-3">${asset_description}</div>${campaign}
                        </div>`;
                        break;
                    case "QRCode":
                        anchor.href = `/qrcode/edit/${asset.asset_id}`;
                        anchor.innerHTML = `${asset_icon}
                        <div style="width:100%">
                        <div class="name">QR Codes<i class="fa-regular fa-angle-right ms-1 me-1" aria-hidden="true"></i>${asset.name}</div>
                        <div class="description clamp-3">${asset_description}</div>${campaign}
                        </div>`;
                        break;
                    case "Campaign":
                        anchor.href = `/campaign/detail/${asset.asset_id}`;
                        anchor.innerHTML = `${asset_icon}
                        <div style="width:100%">
                        <div class="name">Campaigns<i class="fa-regular fa-angle-right ms-1 me-1" aria-hidden="true"></i>${asset.name}</div>
                        <div class="description clamp-3">${asset_description}</div>
                        </div>`;
                        break;
                    case "Poll":
                        anchor.href = `/poll/${asset.asset_id}/edit`;
                        anchor.innerHTML = `${asset_icon}
                        <div style="width:100%">
                        <div class="name">Polls<i class="fa-regular fa-angle-right ms-1 me-1" aria-hidden="true"></i>${asset.name}</div>
                        <div class="description clamp-3">${asset_description}</div>
                        </div>`;
                        break;
                    case "Event":
                        anchor.href = `/event/${asset.asset_id}/detail`;
                        anchor.innerHTML = `${asset_icon}
                        <div style="width:100%">
                        <div class="name">Events<i class="fa-regular fa-angle-right ms-1 me-1" aria-hidden="true"></i>${asset.name}</div>
                        <div class="description clamp-3">${asset_description}</div>
                        </div>`;
                        break;
                    case "TrackingLink":
                        anchor.href = `/linktracking/edit/${asset.asset_id}`;
                        anchor.innerHTML = `${asset_icon}
                        <div style="width:100%">
                        <div class="name">URL Shorteners<i class="fa-regular fa-angle-right ms-1 me-1" aria-hidden="true"></i>${asset.name}</div>
                        <div class="description clamp-3">${asset_description}</div>
                        </div>`;
                        break;
                    case "ContentPage":
                        anchor.href = `/contentpage/edit/${asset.asset_id}`;
                        anchor.innerHTML = `${asset_icon}
                        <div style="width:100%">
                        <div class="name">Landing Pages<i class="fa-regular fa-angle-right ms-1 me-1" aria-hidden="true"></i>${asset.name}</div>
                        <div class="description clamp-3">${asset_description}</div>
                        </div>`;
                        break;
                    case "Popup":
                        anchor.href = `/popup/edit/${asset.asset_id}`;
                        anchor.innerHTML = `${asset_icon}
                        <div style="width:100%">
                        <div class="name">Popups<i class="fa-regular fa-angle-right ms-1 me-1" aria-hidden="true"></i>${asset.name}</div>
                        <div class="description clamp-3">${asset_description}</div>
                        </div>`;
                        break;
                }

                anchor.innerHTML += `<i class="fa-regular fa-angle-right navigate-to"></i>`;

                search_results.appendChild(anchor);
            });

        } catch (err) {
            console.error("Search error:", err);
        }
    }

    function getAssetIcon(asset_type) {

        switch (asset_type) {
            case "TextMessage":
                return '<i class="fa-duotone fa-regular fa-comment-sms asset-icon"></i>';
            case "Segment":
                return '<i class="fad fa-users asset-icon" aria-hidden="true"></i>';
            case "Automation":
                return '<i class="fas fa-user-robot asset-icon" aria-hidden="true"></i>';
            case "Email":
                return '<i class="fas fa-envelope asset-icon" aria-hidden="true"></i>';
            case "WebForm":
                return '<i class="far fa-clipboard-list-check asset-icon" aria-hidden="true"></i>';
            case "Campaign":
                return '<i class="fas fa-bullhorn asset-icon" aria-hidden="true"></i>';
            case "Contact":
                return '<i class="fa-duotone fa-light fa-user asset-icon"></i>';
            case "MagicForm":
                return '<i class="fas fa-magic asset-icon" aria-hidden="true"></i>';
            case "QRCode":
                return '<i class="fad fa-qrcode asset-icon" aria-hidden="true"></i>';
            case "Event":
                return '<i class="fa-duotone fa-regular fa-calendar-circle-plus asset-icon"></i>';
            case "Poll":
                return '<i class="fa-duotone fa-regular fa-square-poll-horizontal asset-icon"></i>';
            case "TrackingLink":
                return '<i class="fas fa-link asset-icon" aria-hidden="true"></i>';
            case "ContentPage":
                return '<i class="fas fa-images asset-icon" aria-hidden="true"></i>';
            case "Popup":
                return '<i class="far fa-window-alt asset-icon" aria-hidden="true"></i>';
        }
    }

    function getStatusPill(asset_type, status) {

        if (asset_type == "Automation") {
            if (status == "Paused")
                return '<span class="dot red ms-1" title="Not Running"></span>';
        }

        return '';
    }

    function isSpacesOrAlphanumeric(str) {
        return /^[a-zA-Z0-9\s]*$/.test(str);
    }

    async function searchContacts(query) {
        const asset_icon = getAssetIcon("Contact");
        const search_all = `/contact/search?s=${searchInput.value}`;

        // Search all contacts
        search_results.innerHTML = `<a class="d-flex align-items-center cg-3 search-result-item" href="${search_all}">${asset_icon}
                        <div style="width:100%">
                        <div class="name">Contacts <i class="fa-regular fa-angle-right ms-1 me-1" aria-hidden="true"></i>Search all</div>
                        </div><i class="fa-regular fa-angle-right navigate-to" aria-hidden="true"></i></a>`;

        // Wild card if we don't contain special characters
        if (isSpacesOrAlphanumeric(query) && query.indexOf('*') === -1)
            query += '*';

        try {
            const response = await fetch(
                `/api/v1/contact/search?s=${encodeURIComponent(query)}`,
                { method: "GET" }
            );

            if (!response.ok) {
                console.error("Search failed:", response.status);
                return;
            }

            const json = await response.json();
            const results = json.Response.results;

            results.slice(0, 10).forEach(contact => {
                const anchor = document.createElement("a");
                anchor.classList.add("d-flex", "align-items-center", "cg-3", "search-result-item");
                anchor.href = `/Contact/Detail/${contact.dsId}`;

                const location = (contact.region || contact.city || contact.country) ? `<div class="d-flex cg-1 text-xs ms-1" style="align-items: baseline;color:var(--color-gray-60)"><span>${contact.city}</span><span>${contact.region}</span><span>${contact.country}</span></div>` : '';

                anchor.innerHTML = `${asset_icon}<div><span class="name">${contact.fullname}${location}</span><div class="d-flex cg-2 text-xs" style="color:var(--color-gray-60)"><span class="mobilePhone"><i class="fa-regular fa-comment-sms me-1"></i>${contact.mobilePhone}</span><span class="email"><i class="fa-sharp-duotone fa-regular fa-at me-1"></i>${contact.email}</span></div></div>`;

                search_results.appendChild(anchor);
            });

        } catch (err) {
            console.error("Search error:", err);
        }
    }

    function escapeHtml(value) {
        const div = document.createElement("div");
        div.textContent = value ?? "";
        return div.innerHTML;
    }

    // NotStarted -> Not Started, InProgress -> In Progress
    function friendlyEnum(value) {
        return (value || "").replace(/([a-z])([A-Z])/g, "$1 $2");
    }

    /**
     * Opportunities tab: sales opportunities and tickets (shown as Tasks,
     * matching the Sales menu). Only rendered for accounts with Sales enabled.
     */
    async function searchCrm(query) {
        try {
            const response = await fetch(
                `/api/v1/sales/globalsearch?s=${encodeURIComponent(query)}`,
                { method: "GET" }
            );

            if (!response.ok) {
                console.error("Search failed:", response.status);
                return;
            }

            const json = await response.json();
            const opportunities = json.Response.opportunities || [];
            const tickets = json.Response.tickets || [];

            // A slower earlier request may land after the user has moved on
            if (searchInput.value.trim() !== query || currentSearchType !== "crm") return;

            search_results.innerHTML = "";

            opportunities.forEach(deal => {
                const anchor = document.createElement("a");
                anchor.classList.add("d-flex", "align-items-center", "cg-3", "search-result-item");
                anchor.href = `/sales/opportunity/${encodeURIComponent(deal.id)}`;

                const stage_color = deal.bucket === "Won" ? "green" : (deal.bucket === "Lost" ? "gray" : "blue");
                const description = [deal.company, deal.contact_name].filter(Boolean).map(escapeHtml).join(" &bull; ");

                anchor.innerHTML = `<i class="fa-duotone fa-regular fa-handshake asset-icon" aria-hidden="true"></i>
                    <div style="width:100%">
                    <div class="name">Opportunities<i class="fa-regular fa-angle-right ms-1 me-1" aria-hidden="true"></i><div class="d-flex align-items-center">${escapeHtml(deal.name)}<span class="pill ${stage_color} ms-2">${escapeHtml(deal.stage)}</span></div></div>
                    <div class="description clamp-3">${description}</div>
                    </div><i class="fa-regular fa-angle-right navigate-to"></i>`;

                search_results.appendChild(anchor);
            });

            tickets.forEach(ticket => {
                const anchor = document.createElement("a");
                anchor.classList.add("d-flex", "align-items-center", "cg-3", "search-result-item");
                anchor.href = `/ticket/detail/${encodeURIComponent(ticket.id)}`;

                const status_color = ticket.ticket_status === "Completed" ? "green" : "gray";
                const overdue = ticket.is_overdue && ticket.ticket_status !== "Completed"
                    ? '<span class="dot red ms-1" title="Overdue"></span>'
                    : "";

                anchor.innerHTML = `<i class="fa-duotone fa-regular fa-list-check asset-icon" aria-hidden="true"></i>
                    <div style="width:100%">
                    <div class="name">Tasks<i class="fa-regular fa-angle-right ms-1 me-1" aria-hidden="true"></i><div class="d-flex align-items-center">${escapeHtml(ticket.name)}<span class="pill ${status_color} ms-2">${escapeHtml(friendlyEnum(ticket.ticket_status))}</span>${overdue}</div></div>
                    <div class="description clamp-3">${escapeHtml(friendlyEnum(ticket.ticket_type))}</div>
                    </div><i class="fa-regular fa-angle-right navigate-to"></i>`;

                search_results.appendChild(anchor);
            });

            if (opportunities.length === 0 && tickets.length === 0) {
                search_results.innerHTML = `<div class="me-3 ms-3 mb-3">No opportunities or tasks were found</div>`;
            }

        } catch (err) {
            console.error("Search error:", err);
        }
    }

    /**
     * Perform a streaming search for Help Docs
     */
    async function searchHelpDocs(query, search_results, signal) {
        await ensureSearchDependencies();

        const purifyConfig = {
            ALLOWED_TAGS: ['p', 'br', 'b', 'i', 'strong', 'em', 'img', 'a', 'ul', 'ol', 'li', 'code', 'pre', 'span'],
            ALLOWED_ATTR: ['href', 'src', 'alt', 'title', 'target', 'class'],
            ADD_ATTR: ['target'],
            FORBID_ATTR: ['onerror', 'onclick']
        };

        if (!query) return;

        // Show your loader if you have one
        const loader = document.querySelector('.progress-loader .bar');
        if (loader) loader.classList.remove('d-none');

        // Clear previous results
        search_results.innerHTML = "";

        try {
            // Updated to your stream endpoint
            const response = await fetch(`https://docs.dailystory.com/api/v1/public/search/stream?s=${encodeURIComponent(query)}`, {
                method: 'GET',
                signal: signal
            });

            if (!response.ok) throw new Error(`HTTP error ${response.status}`);

            const reader = response.body.getReader();
            const decoder = new TextDecoder();
            let accumulatedAnswer = "";
            let metadataRendered = false;
            let buffer = "";

            while (true) {
                const { value, done } = await reader.read();
                if (done) break;

                buffer += decoder.decode(value, { stream: true });
                const parts = buffer.split("\n\n");
                buffer = parts.pop();

                for (const line of parts) {
                    if (!line.startsWith("data: ")) continue;

                    try {
                        const json = JSON.parse(line.replace("data: ", ""));
                        const data = json.results;

                        // Initial render of the containers and article list
                        if (data.posts && !metadataRendered) {
                            data.is_answered ? renderAnswerContainer(data, search_results, query) : renderResultsOnly(data, search_results, query);
                            metadataRendered = true;
                        }

                        // Update the streaming AI answer
                        if (data.is_streaming && data.answer) {
                            accumulatedAnswer += data.answer;
                            const answerContainer = document.querySelector('.search-answer');

                            if (answerContainer && !isIncompleteMarkdown(accumulatedAnswer)) {
                                const rawHtml = marked.parse(accumulatedAnswer);
                                answerContainer.innerHTML = DOMPurify.sanitize(rawHtml, purifyConfig);
                            }
                        }
                    } catch (e) {
                        console.warn("SSE Parse Error:", e);
                    }
                }
            }
        } catch (error) {
            if (error.name === 'AbortError') return;
            console.error('Search failed:', error);
        } finally {
            if (loader) loader.classList.add('d-none');
        }
    }

    /**
     * Checks for Marked and DOMPurify; loads them from CDN if missing
     */
    async function ensureSearchDependencies() {
        const dependencies = [
            {
                name: 'marked',
                url: 'https://cdn.jsdelivr.net/npm/marked/marked.min.js',
                check: () => typeof marked !== 'undefined'
            },
            {
                name: 'DOMPurify',
                url: 'https://cdn.jsdelivr.net/npm/dompurify/dist/purify.min.js',
                check: () => typeof DOMPurify !== 'undefined'
            }
        ];

        const loads = dependencies.map(dep => {
            if (dep.check()) return Promise.resolve();

            return new Promise((resolve, reject) => {
                const script = document.createElement('script');
                script.src = dep.url;
                script.async = true;
                script.onload = resolve;
                script.onerror = () => reject(new Error(`Failed to load ${dep.name}`));
                document.head.appendChild(script);
            });
        });

        return Promise.all(loads);
    }

    /**
     * Helper to prevent rendering broken Markdown during stream
     */
    function isIncompleteMarkdown(str) {
        const openBrackets = (str.match(/\[/g) || []).length;
        const closeBrackets = (str.match(/\]/g) || []).length;
        const openParens = (str.match(/\(/g) || []).length;
        const closeParens = (str.match(/\)/g) || []).length;
        return openBrackets > closeBrackets || openParens > closeParens || /[!\[\]\(\)]$/.test(str);
    }

    /**
     * Renders the AI Answer box AND the documentation links
     */
    function renderAnswerContainer(data, container, query) {
        const wrapper = document.createElement('div');
        wrapper.classList.add("answer-wrapper", "mb-4", "ms-3", "me-3");
        wrapper.innerHTML = `
        <h5 class="mb-1">AI-Generated Answer</h5>
        <p class="text-muted small mb-3">Sourced from our <a target="_blank" href="https://docs.dailystory.com">documentation</a>.</p>
        <article class="search-answer mb-4"></article>
    `;

        container.appendChild(wrapper);
    }

    /**
     * Standard list view if no AI answer is available
     */
    function renderResultsOnly(data, container, query) {
        const listContainer = document.createElement('div');
        listContainer.classList.add('search-results-list');
        container.appendChild(listContainer);
        renderResultItems(data.posts, listContainer, query);
    }

    /**
     * Common logic to render the actual documentation links (using your original FA styles)
     */
    function renderResultItems(posts, container, query) {
        posts.slice(0, 10).forEach(post => {
            const anchor = document.createElement("a");
            anchor.classList.add("d-flex", "align-items-center", "cg-3", "search-result-item");

            // Build Base URL
            let finalUrl = `https://docs.dailystory.com/${post.slug}`;
            if (post.section_anchor) {
                const hash = post.section_anchor.startsWith('#') ? '' : '#';
                finalUrl += `${hash}${post.section_anchor}`;
            }
            anchor.href = finalUrl;
            anchor.target = "_blank";
            anchor.rel = "noopener noreferrer";

            const hasSection = post.section && post.section.length > 0;
            const displayName = hasSection
                ? `<span class="parent">${post.title}<i class="fa-regular fa-angle-right ms-1 me-1" aria-hidden="true"></i></span><span class="child">${post.section}</span>`
                : `<span class="parent">${post.title}</span>`;

            anchor.innerHTML = `
            <i class="fa-duotone fa-solid fa-file-lines asset-icon"></i>
            <div style="width:100%">
                <div class="name">${displayName}</div>
                <div class="description clamp-2">${post.excerpt ?? ""}</div>
            </div>
            <i class="fa-regular fa-arrow-up-right navigate-to"></i>`;

            // Analytics logging
            anchor.addEventListener('click', () => {
                const payload = JSON.stringify({ query: query, result: 'click', postuid: post.postuid });
                navigator.sendBeacon('https://docs.dailystory.com/api/v1/public/search/log', new Blob([payload], { type: 'application/json' }));
            });

            container.appendChild(anchor);
        });
    }


    async function searchDeveloperDocs(query) {
        try {
            const response = await fetch(
                `https://dev.dailystory.com/api/v1/public/search?s=${encodeURIComponent(query)}`,
                { method: "GET" }
            );

            if (!response.ok) {
                console.error("Search failed:", response.status);
                return;
            }

            const json = await response.json();
            const posts = json.results.posts;

            posts.slice(0, 10).forEach(post => {
                const anchor = document.createElement("a");
                anchor.classList.add("d-flex", "align-items-center", "cg-3", "search-result-item");
                anchor.href = `https://dev.dailystory.com/${post.slug}`;

                // Ensure we have a valid section string to work with
                const hasSection = post?.section && post.section.length > 0;

                // Add the anchor if it exists, ensuring the # separator
                if (hasSection && post.section_anchor) {
                    const hash = post.section_anchor.startsWith('#') ? '' : '#';
                    anchor.href += `${hash}${post.section_anchor}`;
                }

                // Build the display name
                const displayName = hasSection
                    ? `<span class="parent">${post.title}<i class="fa-regular fa-angle-right ms-1 me-1" aria-hidden="true"></i></span><span class="child">${post.section}</span>`
                    : `<span class="parent">${post.title}</span>`;

                // Set the final HTML
                anchor.innerHTML = `
                    <i class="fa-duotone fa-solid fa-file-code asset-icon"></i>
                    <div style="width:100%">
                    <div class="name">${displayName}</div>
                    <div class="description clamp-3">${post.excerpt ?? ""}</div>
                    </div><i class="fa-regular fa-arrow-up-right navigate-to"></i>`;

                search_results.appendChild(anchor);
            });

        } catch (err) {
            console.error("Search error:", err);
        }
    }
});
